export default ($axios) => ({
  async getAll(organizationId) {
    return $axios.get(`/organization/${organizationId}/career-sets`);
  },
})
